<template>
    <svg class="spritesheet">
        <symbol id="icon-envelope" viewBox="0 0 32 32">
            <title>envelope</title>
            <path
            d="M31.3937 7.925C31.6375 7.73125 32 7.9125 32 8.21875V21C32 22.6562 30.6562 24 29 24H3C1.34375 24 0 22.6562 0 21V8.225C0 7.9125 0.35625 7.7375 0.60625 7.93125C2.00625 9.01875 3.8625 10.4 10.2375 15.0312C11.5563 15.9937 13.7812 18.0188 16 18.0063C18.2313 18.025 20.5 15.9563 21.7687 15.0312C28.1437 10.4 29.9937 9.0125 31.3937 7.925ZM16 16C17.45 16.025 19.5375 14.175 20.5875 13.4125C28.8812 7.39375 29.5125 6.86875 31.425 5.36875C31.7875 5.0875 32 4.65 32 4.1875V3C32 1.34375 30.6562 0 29 0H3C1.34375 0 0 1.34375 0 3V4.1875C0 4.65 0.2125 5.08125 0.575 5.36875C2.4875 6.8625 3.11875 7.39375 11.4125 13.4125C12.4625 14.175 14.55 16.025 16 16Z">
            </path>
        </symbol>
    </svg>

    <footer class="p-5 bg-dark">
        <div class="container">
            <div class="row">
                <div class="col-6 col-md-2 mb-3">
                    <h5 class="text-light pop700">Company</h5>
                    <ul class="nav flex-column">
                        <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-white-50 pop400">About Us</a></li>
                        <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-white-50 pop400">Team</a></li>
                        <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-white-50 pop400">Careers</a></li>
                        <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-white-50 pop400">Blog</a></li>
                    </ul>
                </div>

                <div class="col-6 col-md-2 mb-3">
                    <h5 class="text-light pop700">Contact</h5>
                    <ul class="nav flex-column">
                        <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-white-50 pop400">Help & Support</a>
                        </li>
                        <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-white-50 pop400">Partner with us</a>
                        </li>
                        <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-white-50 pop400">Ride with us</a>
                        </li>
                    </ul>
                </div>

                <div class="col-6 col-md-2 mb-3">
                    <h5 class="text-light pop700">Legal</h5>
                    <ul class="nav flex-column">
                        <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-white-50 pop400">Terms &
                                Conditions</a></li>
                        <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-white-50 pop400">Refund &
                                Cancellation</a>
                        </li>
                        <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-white-50 pop400">Privacy Policy</a>
                        </li>
                        <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-white-50 pop400">Cookie Policy</a>
                        </li>
                    </ul>
                </div>

                <div class="col-md-5 offset-md-1 mb-3">
                    <div class="mb-5">
                        <h6 class="text-light pop700">Follow Us</h6>
                        <ul class="list-unstyled d-flex gap-3">
                            <li class="ms-3"><a class="socials" href="https://www.instagram.com/badidukkan/" target="_blank"><i
                                        class="fa fa-instagram"></i></a></li>
                            <li class="ms-3"><a class="socials" href="https://www.facebook.com/badidukkan" target="_blank"><i
                                        class="fa fa-facebook"></i></a></li>
                            <li class="ms-3"><a class="socials"
                                    href="https://www.linkedin.com/company/badi-dukkan-india/" target="_blank"><i
                                        class="fa fa-linkedin"></i></a></li>
                        </ul>
                    </div>
                    <div>

                        <h6 class="text-light pop700">Receive exclusive offers in your mailbox</h6>
                        <form class="d-flex flex-column flex-sm-row w-100 gap-2" @submit="submitForm">
                            <label for="newsletter1" class="visually-hidden">Email address</label>
                            <label>
                                <svg class="icon icon-envelope">
                                    <use xlink:href="#icon-envelope"></use>
                                </svg>
                                <input id="newsletter1" type="email" class="form-control pop300"
                                    placeholder="Enter your email" v-model="email" required>
                            </label>
                            <button class="btn btn-sub pop700" type="submit">Subscribe</button>
                        </form>
                    </div>
                </div>
            </div>

            <div class="d-flex flex-column flex-sm-row justify-content-center py-4 my-4 border-top text-light">
                <p class="pop400 text-center">All rights reserved. <span class="open700">© BadiDukkan, 2023</span></p>
            </div>
        </div>
    </footer>
</template>

<style scoped>
.socials {
    color: #fff;
    font-size: 24px;
}

.socials:hover {
    color: #61b752;
}

.btn-sub {
    border-radius: 8px;
    background: linear-gradient(150deg, #7CC528 0%, #70B224 100%);
    box-shadow: 0px 14px 32px 0px rgba(112, 178, 36, 0.25), 0px 5px 8px 0px rgba(112, 178, 36, 0.25);
    color: #fff;
}

.spritesheet {
    display: none;
}

.icon {
    display: inline-block;
    width: 1em;
    height: 1em;
    fill: #adadad;
}

label {
    position: relative;
}

label>.icon {
    position: absolute;
    top: 50%;
    left: 10px;
    transform: translateY(-50%);
    color: #adadad;
}

label>input {
    padding-left: calc(1em + 10px + 8px);
    /* icon width + icon padding-left + desired separation*/
    height: 2em;
}
</style>

<script>
import { db } from '@/firebaseInit';
import swal from 'sweetalert';
import { collection, addDoc, query, where, getDocs } from 'firebase/firestore'
export default {
    methods: {
        async submitForm(e) {
            e.preventDefault()
            let emailref = collection(db, "EmailAddresses")
            let q = query(emailref, where('email', '==', this.email))
            let data = await getDocs(q)
            if (data.size > 0) {
                swal({
                    title: "Already Subscribed!",
                    text: "You have already subscribed to the newsletter!",
                    button: "Ohh!",
                });
                return
            }
            let res = await addDoc(collection(db, "EmailAddresses"), {
                email: this.email
            });

            if (res) {
                swal({
                    title: "Subscribed!",
                    text: "You are now subscribed to the newsletter!",
                    icon: "success",
                    button: "Yayy!",
                });
                this.email = ''
            }
        }
    },
    data() {
        return {
            email: ''
        }
    }
}
</script>